<template>
  <InfiniteScroll class="tab-comic" :load="loadMore" :loading="loading" :isEnd="isEnd">
    <div class="header">
      <span class="title">Discover</span>
      <Tool />
    </div>
    <div class="search-bar">
      <Input placeholder="Click To View Hot Search" @inputClick="$router.push('/novel/search')"/>
    </div>
    <!-- <div class="tab-list">
      <div class="scroll-container">
        <a
          href="javascript:void(0);"
          v-for="(tab, i) in tabList"
          :key="tab.id + '_' +  i"
          :class="['tab', activeTab === tab.name ? 'active': '']"
          @click="(e) => tabChange(e, tab)"
        >
            {{ tab.name }}
        </a>
      </div>
    </div> -->
    <List :list="list" @goChat="goChat"/>
  </InfiniteScroll>
</template>

<script>
import Input from '@/components/Input';
import { mapState } from 'vuex';
import InfiniteScroll from '@/components/InfiniteScroll.vue';
import { getCharacterList } from '@/api';
import Tool from '@/components/Tool';
import List from './components/List';

export default {
  components: {
    Input,
    List,
    InfiniteScroll,
    Tool,
  },
  data() {
    return {
      tabList: [],
      activeTab: 'Recommend',
      list: [],
      loading: false,
      isEnd: false,
      page: 1,
      pageSize: 20,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    async init() {
      this.getCharacterList();
    },
    tabChange(e, tab) {
      if (tab.name === this.activeTab) return;
      e.target.scrollIntoView && e.target.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      this.activeTab = tab.name;
    },
    async getCharacterList() {
      const { page } = this;
      const res = await getCharacterList({ page, per_page: this.pageSize });
      if (res.code !== 0) return;
      this.list = page === 1 ? res.data.data : this.list.concat(res.data.data || []);
      this.isEnd = page >= res.data.total;
      this.loading = false;
    },
    loadMore() {
      this.isEnd = false;
      this.loading = true;
      this.page += 1;
      this.getCharacterList();
    },
    goChat(id) {
      if (!id) return;
      this.$router.push(`/character/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.tab-comic {
  padding: 0 16px;
  min-height: 100%;
  background-image: linear-gradient(to bottom, #c1efc2 5%, #e3f7e4 10%, #fff 100%);
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    line-height: 44px;
    .title {
      font-size: @fontLarge;
      font-weight: 700;
    }
  }
  .search-bar {
    padding: 4px 0 14px;
  }
  .tab-list {
    padding: 14px 0 10px;
    overflow-x: scroll;
    .scroll-container {
      display: inline-flex;
      flex-wrap: nowrap;
      min-width: 100%;
      .tab {
        position: relative;
        font-family: Roboto;
        font-weight: 400;
        line-height: 16px;
        padding-bottom: 10px;
        font-size: 13px;
        margin-right: 22px;
        color: @gray;
        white-space: nowrap;
        &.active {
          color: #1E1E1E;
          font-size: 15px;
          font-weight: 600;
          &::after {
            content: '';
            position: absolute;
            width: 26px;
            height: 3px;
            background-color: @theme;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
}
</style>
